import BaseModel from "./base/baseModel";
import CompraItemModel from "./compraItemModel";

export default class CompraFornecedorModel extends BaseModel {
    id?: number = null;
    compraId?: number = null;
    fornecedorDescricao?: string = null;
    fornecedorId?: number = null;
    unidadeMedidaId?: number = null;
    key?: string = null;
    emailCotacaoEnviado = false;

    //CompraFornecedorDTO
    itens: Array<CompraItemModel> = null;
    razaoSocial?: string = null;
    nomeFantasia?: string = null;
    cnpj?: string = null;
    endereco?: string = null;
    usuarioSolicitacao?: string = null;
}
